import { Component, inject, Input, OnInit } from '@angular/core';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { isSupportTechnique } from '../../../../../../ECoSystemsHelper';
import { P00039 } from '../../../../P00039';
import { IProduct } from '../../../../../IProduct';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { DisplayRubriqueStatusComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status/display-rubrique-status.component';
import { DisplayRubriqueStatusOnOffComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-on-off/display-rubrique-status-on-off.component';
import { DisplayRubriqueStatusWithWarningComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning/display-rubrique-status-with-warning.component';
import { CollapseComponent } from '../../../../../../../../components/ecosystems/collapse/collapse.component';
import { IonItem, IonLabel, IonList } from '@ionic/angular/standalone';
import { DisplayRubriqueStatusWithWarningAndCtaComponent } from '../../../../../../../../components/ecosystems/display-rubrique-status-with-warning-and-cta/display-rubrique-status-with-warning-and-cta.component';

@Component({
  selector: 'app-p00080-altimeo-statut',
  templateUrl: './p00080-altimeo-statut.component.html',
  styleUrls: ['./p00080-altimeo-statut.component.scss'],
  standalone: true,
  imports: [
    DisplayRubriqueStatusComponent,
    DisplayRubriqueStatusOnOffComponent,
    DisplayRubriqueStatusWithWarningComponent,
    TranslatePipe,
    CollapseComponent,
    IonItem,
    IonLabel,
    IonList,
    DisplayRubriqueStatusWithWarningAndCtaComponent,
  ],
})
export class P00080AltimeoStatutComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);
  private translateService: TranslateService = inject(TranslateService);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {}

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  doBinaireOperation(value: number, decalage: number, and: number) {
    return (value >> decalage) & and;
  }

  getValue(key: string): number {
    return this.actionStack!.getValue(key);
  }

  editValue(index: any, key: string, value: any): void {
    this.actionStack!.editValue(index, key, value);
  }

  commit(): void {
    this.actionStack!.commit();
  }

  get presenceProduit(): number {
    return new P00039().hasProduct(
      this.edroNetworkManager.getPoolContext()!.pool!,
      this.productClass!,
    );
  }

  protected readonly isSupportTechnique = isSupportTechnique;
  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
}
